import { ManquementCommissionEdition } from './manquement-commission-edition.model';
import { ManquementMouvementEdition } from './manquement-mouvement-edition.model';
import { ManquementOperateurEdition } from './manquement-operateur-edition.model';
import { OrganismeEdition } from './organisme-edition.model';
import { Defaut } from '../../commission/models/defaut.model';
import { ArrayClassConverterFactory, ClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class ManquementEdition {
    static jsonMap = {
        numero: { key: 'numero', optional: true, default: '' },
        libelle: { key: 'libelle', optional: true, default: '' },
        gravite: { key: 'gravite', optional: true, default: '' },
        commentaireConstat: { key: 'commentaireConstat', optional: true, default: '' },
        commentaireOperateur: { key: 'commentaireOperateur', optional: true, default: '' },
        commentaireOrganisme: { key: 'commentaireOrganisme', optional: true, default: '' },
        commentaireDecision: { key: 'commentaireDecision', optional: true, default: '' },
        dateNotification: { key: 'dateNotification', optional: true, default: '' },
        dateConstat: { key: 'dateConstat', optional: true, default: '' },
        defautsLibelles: { key: 'defautsLibelles', optional: true, default: '' },
        referencePlanControle: { key: 'referencePlanControle', optional: true, default: '' },
        typeControle: { key: 'typeControle', optional: true, default: '' },
        referentielProcedureInterne: { key: 'referentielProcedureInterne', optional: true, default: '' },
        mouvement: { key: 'mouvement', converter: new (ClassConverterFactory.build(ManquementMouvementEdition))(), optional: true },
        operateur: { key: 'operateur', converter: new (ClassConverterFactory.build(ManquementOperateurEdition))(), optional: true },
        commission: { key: 'commission', converter: new (ClassConverterFactory.build(ManquementCommissionEdition))(), optional: true },
        organisme: { key: 'organisme', converter: new (ClassConverterFactory.build(OrganismeEdition))(), optional: true }
    };

    numero: string;
    libelle: string;
    gravite: string;
    commentaireConstat: string;
    commentaireOperateur: string;
    commentaireOrganisme: string;
    commentaireDecision: string;
    dateNotification: string;
    dateConstat: string;
    defautsLibelles: string;
    referencePlanControle: string;
    referentielProcedureInterne: string;
    typeControle: string;
    mouvement: ManquementMouvementEdition;
    operateur: ManquementOperateurEdition;
    commission: ManquementCommissionEdition;
    organisme: OrganismeEdition;
}
